import { defineMessages } from 'react-intl';

export default defineMessages({
    homePhoneLabel: {
        id: 'ml.contactDetails.common.Home Phone',
        defaultMessage: 'Home Phone'
    },
    primaryContactCheckbox: {
        id: 'ml.contactDetails.common.This is my primary contact number',
        defaultMessage: 'This is my primary contact number'
    },
    addPhoneNumberOptions: {
        id: 'ml.contactDetails.common.+ Additional Phone Number Options',
        defaultMessage: '+ Additional Phone Number Options'
    },
    workPhoneLabel: {
        id: 'ml.contactDetails.common.Work Phone',
        defaultMessage: 'Work Phone'
    },
    cellPhoneLabel: {
        id: 'ml.contactDetails.common.Cell Phone',
        defaultMessage: 'Cell Phone'
    },
    editEmailAddressLabel: {
        id: 'ml.contactDetails.common.Email Address',
        defaultMessage: 'Email Address'
    },
    updatesOnEmailAddress: {
        id: 'ml.contactDetails.common.Updates to your email address do not impact the username used to log in.',
        defaultMessage: 'Updates to your email address do not impact the username used to log in.'
    },
    emailUpdateLink: {
        id: 'ml.contactDetails.common.Click here to update your username',
        defaultMessage: 'Click here to update your username'
    },
    spouseEmailAddress: {
        id: 'ml.contactDetails.common.Spouse\'s Email',
        defaultMessage: 'Spouse\'s Email'
    },
    emailScriptHeader: {
        id: 'ml.contactDetails.common.Email Script',
        defaultMessage: 'Email Script'
    },
    emailScriptContent: {
        id: 'ml.contactDetails.common.emailScriptContent',
        defaultMessage: 'When you provide your email address, you consent to receiving emails about your online quote and other product information from third parties working for us who we gave your email address.  We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes.  To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    incompleteInputMsg: {
        id: 'ml.contactDetails.common.Enter a 10 digit phone number without dashes',
        defaultMessage: 'Enter a 10 digit phone number without dashes'
    }
});
